
import ZUtil from './zutil.js';


var ZLog = {
	level: 1,
	log: function(msg, data) {
		return this._log("", msg, data);
	},
	info: function(msg, data) {
		return this._log("", msg, data);
	},
	debug: function(msg, data) {
		if (this.level > 4) {
			this._log("DEBUG: ", msg, data);
		}
	},
	getLevel: function() {
		return this.level;
	},
	setLevel: function(level) {
		this.level = level || 1;
		console.log("Setting debug level: " + this.level);
	},
	special: function(msg, data) {
		this._log("", "SPECIAL ************* \n" + msg + "\n******************SPECIAL", data);
	},
	warn: function(msg, data) {
		this._log("*** WARNING *** ", msg, data);
	},
	error: function(msg, data) {
		console.error("*** ERROR *** " + msg + (data ? "=> " + this._toString(data) : ""));
	},
	trace: function(msg, data) {
		console.error("TRACE: " + msg + (data ? "=> " + this._toString(data) : ""));
	},
	fatal: function(msg, data) {
		this._log("*** FATAL *** ", msg, data);
	},
	_log: function(label, msg, data) {
		console.log(label + " " + msg + (data ? "=> " + this._toString(data) : ""));
	},
	_toString(data) {
		if (typeof data === "string") {
			return data;
		}
		if (Array.isArray(data)) {
			return "[" + data.map( item => { return ZUtil.inspect(item) } ).join(", ") + "]";
		}
		if (Object.keys(data).length > 0) {
			try {
				return Object.keys(data).map(function(k) { return k + "=" + ZUtil.inspect(data[k]) }).join(",");
			} catch (e) {
				return Object.keys(data).map(function(k) { return k + "=" + data[k] }).join(",");
			}
		}
		return  ZUtil.inspect(data); // data.toString();
	},
	wrap: function(fn) {
		if (!fn.__wrapped__) {
			fn.__wrapped__ = function () {
				//try {
					return fn.apply(this, arguments);
				//} catch (e) {
					//console.error(e);
					//self.exception(e); // report the error
					//throw e; // re-throw the error
				//}
			};
		}

		return fn.__wrapped__;
	},
}
export default ZLog;



// WEBPACK FOOTER //
// ./src/zlog.js